import type { ZudokuConfig } from "zudoku";
import { reactQueryPlugin } from "./src/lib/plugins/reactQueryPlugin";

// warning: changing the initial page name will require changes to cloudfront redirects
const INITIAL_PAGE = "/landing";

const config: ZudokuConfig = {
  plugins: [reactQueryPlugin()],
  search: {
    type: "pagefind",
  },
  theme: {
    customCss: `
      h1 {
        font-weight: 600;
      }
      
      h2 {
        font-weight: 600;
      }

      h3 {
        font-weight: 500;
      }

      h4 {
        font-weight: 400;
      }

      .tile-border {
        border: 1px solid #F0F3F5;
        box-shadow: 0px 1px 1px 0 rgba(0, 0, 0, 0.08);
        transition: box-shadow 0.2s ease;
      }

      .tile-border:hover {
        box-shadow: 0 0 0 4px rgba(194, 213, 250, 0.3);
      }

      .site-title, [data-testid="site-title"] {
        display: inline-block !important;
        margin-left: 0.75rem;
        font-size: 1.25rem;
        font-weight: 600;
        color: inherit;
      }

      .icon-success-filter {
        filter: invert(48%) sepia(79%) saturate(2476%) hue-rotate(86deg) brightness(95%) contrast(119%);
      }

    `,
  },
  navigation: [
    {
      type: "category",
      label: "Docs",
      items: [
        {
          type: "doc",
          file: INITIAL_PAGE,
          label: "Quick Start",
        },
        {
          type: "doc",
          file: "docs/playground",
          label: "Playground",
        },
        {
          type: "doc",
          file: "docs/documentation",
          label: "Documentation",
        },
      ],
    },
    {
      type: "category",
      label: "Dashboard",
      items: [
        {
          type: "doc",
          file: "docs/overview",
          label: "Overview",
        },
        {
          type: "category",
          label: "API Keys",
          items: [
            {
              type: "doc",
              file: "docs/api-keys/personal",
              label: "Personal",
            },
            {
              type: "doc",
              file: "docs/api-keys/organisations",
              label: "Organisations",
            },
          ],
        },
        {
          type: "doc",
          file: "docs/usage",
          label: "Usage",
        },
        {
          type: "doc",
          file: "docs/billing",
          label: "Billing",
        },
      ],
    },
    {
      type: "link",
      to: "/api",
      label: "API Reference",
    },
    {
      type: "category",
      label: "Help & Support",
      items: [
        {
          type: "doc",
          file: "docs/support",
          label: "Support",
        },
      ],
    },
  ],
  docs: {
    files: "pages/**/*.{md,mdx}",
    defaultOptions: {
      showLastModified: false,
    },
  },
  apis: [
    {
      type: "file",
      input: "./openapi/openapi-ask-eolas-3.2.yml",
      path: "/api",
    },
  ],
  authentication: {
    type: "openid",
    clientId: process.env.ZUDOKU_PUBLIC_COGNITO_USER_POOL_CLIENT_ID || "",
    issuer: `https://cognito-idp.eu-west-1.amazonaws.com/${
      process.env.ZUDOKU_PUBLIC_COGNITO_USER_POOL_ID || ""
    }`,
    scopes: ["openid", "email", "profile"],
    redirectToAfterSignOut: INITIAL_PAGE,
    redirectToAfterSignUp: "/docs/overview",
  },
  protectedRoutes: [
    "/docs/overview",
    "/docs/api-keys/personal",
    "/docs/api-keys/organisations",
    "/docs/usage",
    "/docs/billing",
  ],
  site: {
    title: "Ask Eolas API Developer Portal",
    logo: {
      src: {
        light: "/appLogo.svg",
        dark: "/appLogo.svg",
      },
      alt: "Ask Eolas API Logo",
      href: "/",
    },
  },
  metadata: {
    title: "Ask Eolas API",
    description: "Developer portal for the Ask Eolas API platform",
    favicon: "/favicon.ico",
  },
  redirects: [
    {
      from: "/",
      to: INITIAL_PAGE,
    },
    {
      from: "/docs/api-keys",
      to: "/docs/api-keys/personal",
    },
  ],
};

export default config;
